import ProcurementOrdersContainer from '@components/containers/procurementOrders';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const ProcurementOrders: FC = () => (
    <AppLayout>
        <ProcurementOrdersContainer />
    </AppLayout>
);

export default ProcurementOrders;
